import { PrintLabelsComponent } from "~/components/admin/dispatch/print-labels";
import PageMeta from "~/components/common/meta";

export const ScreenPrintLabels = () => {
  return (
    <>
      <PageMeta title="Print Labels" />
      <PrintLabelsComponent />
    </>
  );
};
